import React from 'react';
import clx from 'classnames';
import { Col, Row, Space, Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;

import { Link } from 'react-router-dom';
import '../FooterFrontPolicyRow.scss';
import { useTranslation } from 'react-i18next';
import { resolvePublicPath } from 'client/core/appConfig';

export interface FooterFrontPolicyRowProps {
  showTopLine?: boolean;
}

/**
 * Linea finale del Footer delle pagine pubbliche
 * con i link alla policy definiti nel file di traduzione
 */
export function MicFooterFrontPolicyRow(props: FooterFrontPolicyRowProps) {
  const { t } = useTranslation();

  return (
    <Row
      className={clx('footer-front-policy-row', {
        'top-line': props.showTopLine
      })}
    >
      <Col>
        {t('mic:footer.static-text', 'MiC - Direzione Generale Organizzazione')}
      </Col>
      <Col className="policy-colums">
        <Space
          className="policy-link-wrapper"
          direction="horizontal"
          size="large"
        >
          <a
            href="https://form.agid.gov.it/view/95d54a21-0152-4645-8b3f-f3800d835bb6/"
            target="_blank"
          >
            {t(
              'mic:footer.policy.accessibility-declaration-text',
              'Dichiarazione di accessibilità'
            )}
          </a>
          <a
            href={`${resolvePublicPath(
              t(
                'mic:footer.policy.privacy-cookie-policy-file-name',
                'privacy_e_cookie_policy.pdf'
              )
            )}`}
            target="_blank"
          >
            {t(
              'mic:footer.policy.privacy-cookie-policy-text',
              'Privacy e cookie policy'
            )}
          </a>
        </Space>
      </Col>
    </Row>
  );
}
